import { useCallback, useRef } from "react";
import type { KeycloakLike } from "../types";

/**
 * Returns a stable getter for a non-expired bearer token, or null when the refresh
 * fails. Stable on purpose: it is a dependency of the socket effect, and a new
 * identity per render would tear the connection down and rebuild it every second.
 * The live kc is read through a ref so the identity can stay put.
 */
export function useFreshToken(kc: KeycloakLike): () => Promise<string | null> {
  const kcRef = useRef(kc);
  kcRef.current = kc;

  return useCallback(async () => {
    try {
      await kcRef.current.updateToken(60);
      const token = kcRef.current.token;
      return token && token.trim().length ? token : null;
    } catch {
      return null;
    }
  }, []);
}
